export const baseSpacing = 24;

export const headerHeight = 72;

export const sidebarClosedWidth = 72;
// export const sidebarClosedWidth = 260;
export const sidebarOpenWidth = 352;
